<script>
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { getEstatisticasPergunta } from '../../services/pesquisa'
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    idPergunta: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      estatisticas: {},
    }
  },
  mounted () {
    this.addPlugin([
      ChartDataLabels,
      {
        id: 'backgound-plugin',
        beforeDraw: function(chartInstance) {
          var ctx = chartInstance.chart.ctx;
          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
        }
      }
    ])
    this.getEstatisticasPergunta()
  },
  methods: {
    async getEstatisticasPergunta () {
      try {
        this.loading = true
        const palette = ['#F44336', '#1E88E5', '#0097A7', '#66BB6A', '#FDD835', '#FB8C00', '#FB8C00', '#FB8C00']
        const response = await getEstatisticasPergunta({ idPergunta: this.idPergunta })
        // const palette = (distinctColors({ count: response.respostas.length, hueMin: 0, hueMax: 60 })).map(x => {
        //   return `rgb(${x._rgb.join(', ')})`
        // })
        const chartData = {
          labels: response.respostas.map(x => x.resposta),
          datasets: [
            {
              backgroundColor: palette,
              // label: 'Respostas',
              data: response.respostas.map(x => x.total)
            }
          ]
        }

        const chartOptions = {
          backgroundColor: '#FFF',
          title: {
            fontSize: 20,
            display: true,
            text: this.titulo
          },
          tooltips: {
            enabled: true
          },
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                const total = context.chart.data.datasets[0]
                  .data
                  .reduce((previous, current) => previous + current, 0)
                const percentage = ((value / total) * 100).toFixed(2)
                return `${percentage}%`
              },
              color: "white",
              textAlign: "center",
              font: {
                weight: "bold",
                size: 16
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
        this.renderChart(chartData, chartOptions)
        // console.log(this.series);
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    getSeries () {
      try {
        this.series = this.estatisticas.respostas.map(x => x.total)
        return 
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>